import { useEffect, useId, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import styles from './Modal.module.css'

interface Props {
  title: string
  onClose: () => void
  children: ReactNode
  width?: number
  /** Без шапки и полей: содержимое рисует себя само от края до края (карточка профиля). */
  bare?: boolean
}

/** Модальное окно поверх всего: Esc и клик по подложке закрывают. */
export function Modal({ title, onClose, children, width = 440, bare = false }: Props) {
  const titleId = useId()
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation()
        onClose()
      }
    }
    document.addEventListener('keydown', onKey, true)
    return () => document.removeEventListener('keydown', onKey, true)
  }, [onClose])

  return createPortal(
    <div className={styles.backdrop} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className={styles.card} role="dialog" aria-modal="true" aria-labelledby={titleId} aria-label={bare ? title : undefined} style={{ width }}>
        {bare ? (
          <button type="button" className={`${styles.close} ${styles.closeFloating}`} aria-label="Закрыть" onClick={onClose}><X size={20} /></button>
        ) : (
          <header className={styles.header}>
            <h2 id={titleId} className={styles.title}>{title}</h2>
            <button type="button" className={styles.close} aria-label="Закрыть" onClick={onClose}><X size={22} /></button>
          </header>
        )}
        <div className={bare ? styles.bodyBare : styles.body}>{children}</div>
      </div>
    </div>,
    document.fullscreenElement ?? document.body,
  )
}
